import { TYPE } from '../actions/types'

export default function (state = {}, action) {
    switch (action.type) {
        case TYPE.GET_AMENTIES:
            return { ...state, response: action.payload }
        case TYPE.UPDATE_AMENTIES:
            return { ...state, response: action.payload }
        default:
            return state;
    }
}

